import { AiProcessingStatusSchema } from '@/shared/apis/broadcast-vault/types';

export const contentAiProcessingStatusSchema =
  AiProcessingStatusSchema.nullable().optional();
